module.exports = __webpack_public_path__ + "static/media/Tazewell_Lifestyle.873ee28f.png";